<template>
  <AgentFab />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import AgentFab from './components/AgentFab.vue';
import { useAgentStore } from './stores/agent.store';

const store = useAgentStore();
onMounted(() => store.loadConfig());
</script>
